import {
	CONTRACT_FEES_COUNT,
	CONTRACT_FEES_GET,
	CONTRACT_FEES_GET_ALL,
	CONTRACT_FEES_SAVE,
	CONTRACT_FEES_ADD_UPDATE,
	CONTRACT_FEES_ERROR,
	CONTRACT_FEES_CLEAR,
	CONTRACT_FEES_CLEAR_ALL_UPDATES,
	CONTRACT_FEES_REMOVE_ALL_EDITS
} from '../Enums/Contract.Fees.Enums';

const initState = {
	data: [],
	dataCopy: [],
	all_data: [],
	errors: [],
	updated: [],
	hasUpdates: false,
	isLoaded: false,
	count: { total: 0, complete: 0 },
	message: ''
};

const fees = (state = initState, action) => {
	let updatedState = {};

	switch (action.type) {
		case CONTRACT_FEES_GET: {
			let { data, dataCopy, errors } = action.payload;
			updatedState = {
				...state,
				data,
				dataCopy,
				errors,
				message: '',
				isLoaded: true
			};
			break;
		}
		case CONTRACT_FEES_GET_ALL: {
			updatedState = {
				...state,
				isLoaded: true,
				all_data: action.payload.data,
				errors: action.payload.errors
			};
			break;
		}
		case CONTRACT_FEES_COUNT: {
			let { data, errors } = action.payload;
			updatedState = {
				...state,
				count: {
					total: data.total,
					complete: data.complete
				},
				errors,
				isLoaded: true
			};
			break;
		}
		case CONTRACT_FEES_SAVE: {
			const { message, errors } = action.payload;
			updatedState = {
				...state,
				errors,
				hasUpdates: false,
				message,
				updated: []
			};
			break;
		}
		case CONTRACT_FEES_ADD_UPDATE:
			updatedState = {
				...state,
				updated: action.payload.updates,
				hasUpdates: action.payload.updates.length > 0
			};
			break;
		case CONTRACT_FEES_ERROR: {
			const { errors } = action.payload;
			updatedState = {
				...state,
				errors,
				isLoaded: true
			};
			break;
		}
		case CONTRACT_FEES_CLEAR: {
			const { errors } = action.payload;
			updatedState = {
				...state,
				errors,
				message: ''
			};
			break;
		}
		case CONTRACT_FEES_CLEAR_ALL_UPDATES: {
			updatedState = {
				...state,
				updated: [],
				hasUpdates: false
			};
			break;
		}
		case CONTRACT_FEES_REMOVE_ALL_EDITS: {
			updatedState = {
				...state,
				data: action.payload.data,
				updated: [],
				hasUpdates: false
			};
			break;			
		}
		default:
			return state;
	}
	return updatedState;
};

export default fees;
